"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.CardRenderEffectBoxComponent = void 0;
var vue_1 = require("vue");
var CardRenderItemComponent_1 = require("./CardRenderItemComponent");
var CardRenderSymbolComponent_1 = require("./CardRenderSymbolComponent");
var CardRenderer_1 = require("../../cards/render/CardRenderer");
var CardProductionBoxComponent_1 = require("./CardProductionBoxComponent");
var CardRenderTileComponent_1 = require("./CardRenderTileComponent");
var CardRenderSymbol_1 = require("../../cards/render/CardRenderSymbol");
var CardRenderItem_1 = require("../../cards/render/CardRenderItem");
var CardDescription_1 = require("./CardDescription");
exports.CardRenderEffectBoxComponent = vue_1.default.component('CardRenderEffectBoxComponent', {
    props: {
        effectData: {
            type: Object,
            required: true,
        },
    },
    components: {
        CardRenderItemComponent: CardRenderItemComponent_1.CardRenderItemComponent,
        CardRenderSymbolComponent: CardRenderSymbolComponent_1.CardRenderSymbolComponent,
        CardProductionBoxComponent: CardProductionBoxComponent_1.CardProductionBoxComponent,
        CardRenderTileComponent: CardRenderTileComponent_1.CardRenderTileComponent,
        CardDescription: CardDescription_1.CardDescription,
    },
    methods: {
        getClasses: function () {
            var classes = ['card-effect-box'];
            return classes.join(' ');
        },
        getComponentType: function (rowItem) {
            if (rowItem instanceof CardRenderSymbol_1.CardRenderSymbol) {
                return 'symbol';
            }
            else if (rowItem instanceof CardRenderer_1.CardRenderProductionBox) {
                return 'production';
            }
            else if (rowItem instanceof CardRenderItem_1.CardRenderItem) {
                return 'item';
            }
            else if (rowItem instanceof CardRenderer_1.CardRenderTile) {
                return 'tile';
            }
            return '';
        },
        hasDescription: function () {
            return this.effectData.description !== undefined;
        },
    },
    template: "\n      <div :class=\"getClasses()\">\n        <div class=\"card-effect-box-row\">\n            <div v-if=\"effectData.delimiter !== undefined\" class=\"card-effect-box-content\">\n                <div v-for=\"(rowItem, rowIndex) in effectData.cause\" class=\"card-effect-box-item\" :key=\"rowIndex\"> \n                  <CardRenderItemComponent v-if=\"getComponentType(rowItem) === 'item'\" :item=\"rowItem\"/>\n                  <CardRenderSymbolComponent v-else-if=\"getComponentType(rowItem) === 'symbol'\" :item=\"rowItem\" />\n                  <CardProductionBoxComponent v-else-if=\"getComponentType(rowItem) === 'production'\" :rows=\"rowItem.rows\" />\n                  <CardRenderTileComponent v-if=\"getComponentType(rowItem) === 'tile'\" :item=\"rowItem\"/>\n                </div>\n            </div>\n            <CardRenderSymbolComponent v-if=\"effectData.delimiter !== undefined\" :item=\"effectData.delimiter\" />\n            <div class=\"card-effect-box-content\">\n                <div v-for=\"(rowItem, rowIndex) in effectData.effect\" class=\"card-effect-box-item\" :key=\"rowIndex\">\n                    <CardRenderItemComponent v-if=\"getComponentType(rowItem) === 'item'\" :item=\"rowItem\"/>\n                    <CardRenderSymbolComponent v-else-if=\"getComponentType(rowItem) === 'symbol'\" :item=\"rowItem\" />\n                    <CardProductionBoxComponent v-else-if=\"getComponentType(rowItem) === 'production'\" :rows=\"rowItem.rows\" />\n                    <CardRenderTileComponent v-if=\"getComponentType(rowItem) === 'tile'\" :item=\"rowItem\"/>\n                </div>\n            </div>\n        </div>\n        <CardDescription v-if=\"hasDescription()\" :item=\"effectData.description\" />\n      </div>\n    ",
});
//# sourceMappingURL=CardRenderEffectBoxComponent.js.map